module.exports = __webpack_public_path__ + "img/install.c4dd2e47.png";